import User from '@/utils/user';
import Drawer from '@/utils/drawer';
import Modals from '@/utils/modals';
import Config from '@/config';
import ConfigVcht from '@/config.vcht';

import { isVcht, isVrn, isMobile, isSafari, isMobileSafari, isApple, isProductionMode, isDevelopmentMode, isVchtMode } from '@/constants/global';

export default {
  install(Vue) {
    Vue.component('api-form', () => import('@/components/global/ApiForm.vue'));
    Vue.component('tooltip-wrap', () => import('@/components/global/TooltipWrap.vue'));
    Vue.component('server-data', () => import('@/components/global/ServerData.vue'));
    Vue.component('data-handler', () => import('@/components/global/DataHandler.vue'));
    Vue.component('v-autocomplete-more', () => import('@/components/global/VAutocompleteMore.vue'));
    Vue.component('ev-autocomplete', () => import('@/components/global/ui/EvAutocomplete.vue'));
    Vue.component('ev-combobox', () => import('@/components/global/ui/EvCombobox.vue'));
    Vue.component('ev-select', () => import('@/components/global/ui/EvSelect.vue'));
    Vue.component('ev-text-field', () => import('@/components/global/ui/EvTextField.vue'));
    Vue.component('ev-datetime-field', () => import('@/components/global/ui/EvDatetimeField.vue'));
    Vue.component('ev-image-preview', () => import('@/components/global/ui/EvImagePreview.vue'));
    Vue.component('ev-drawer', () => import('@/components/global/ui/EvDrawer.vue'));
    Vue.component('ev-dialog', () => import('@/components/global/ui/EvDialog.vue'));
    Vue.component('breadcrumbs', () => import('@/components/core/Breadcrumbs.vue'));
    Vue.component('select-menu', () => import('@/components/global/SelectMenu.vue'));
    Vue.component('ev-carousel', () => import('@/components/global/ui/EvCarousel.vue'));
    Vue.component('ev-items-row', () => import('@/components/global/ui/EvItemsRow.vue'));
    Vue.component('v-file-uploader', () => import('@/components/inputs/vFileUploader.vue'));
    Vue.component('list-detail', () => import('@/components/global/list-detail/ListDetail.vue'));
    Vue.component('extended-list-detail', () => import('@/components/global/ExtendedListDetail.vue'));
    Vue.component('ev-tiptap-editor', () => import('@/components/global/ui/EvTiptapEditor.vue'));

    Vue.component('dialogs-container', () => import('@/packages/ev-dialogs/components/DialogsContainer.vue'));

    Vue.component('drawers-container', () => import('@/packages/ev-drawers/components/DrawersContainer.vue'));

    // UI Redesign
    Vue.component('text-loader', () => import('@/components/user-redesign/layout/TextLoader.vue'));
    Vue.component('app-button', () => import('@/components/user-redesign/controls/AppButton.vue'));
    Vue.component('app-text-input', () => import('@/components/user-redesign/inputs/AppTextInput.vue'));
    Vue.component('app-select', () => import('@/components/user-redesign/inputs/AppSelect/AppSelect.vue'));
    Vue.component('app-autocomplete', () => import('@/components/user-redesign/inputs/AppAutocomplete.vue'));
    Vue.component('app-textarea', () => import('@/components/user-redesign/inputs/AppTextarea.vue'));
    // DEPRECATED, replace with AppTextarea
    Vue.component('app-text-area-old', () => import('@/components/user-redesign/inputs/AppTextAreaOld.vue'));
    Vue.component('app-checkbox', () => import('@/components/user-redesign/inputs/AppCheckbox.vue'));
    // DEPRECATED, replace with AppCheckbox
    Vue.component('app-checkbox-old', () => import('@/components/user-redesign/inputs/AppCheckboxOld.vue'));
    Vue.component('app-radio-group', () => import('@/components/user-redesign/inputs/AppRadioGroup.vue'));
    Vue.component('app-list', () => import('@/components/user-redesign/list/AppList.vue'));
    Vue.component('app-list-item', () => import('@/components/user-redesign/list/AppListItem.vue'));
    Vue.component('app-list-item-action', () => import('@/components/user-redesign/list/AppListItemAction.vue'));
    Vue.component('app-list-item-group', () => import('@/components/user-redesign/list/AppListItemGroup.vue'));
    Vue.component('app-menu', () => import('@/components/user-redesign/AppMenu.vue'));
    Vue.component('app-calendar', () => import('@/components/user-redesign/inputs/AppCalendar/AppCalendar.vue'));
    Vue.component('app-overlay', () => import('@/components/user-redesign/AppOverlay.vue'));
    Vue.component('app-chip', () => import('@/components/user-redesign/chips/AppChip.vue'));
    Vue.component('app-chip-group', () => import('@/components/user-redesign/chips/AppChipGroup.vue'));
    Vue.component('app-tabs', () => import('@/components/user-redesign/tabs/AppTabs.vue'));
    Vue.component('app-tab', () => import('@/components/user-redesign/tabs/AppTab.vue'));
    Vue.component('tabs-config', () => import('@/components/user-redesign/tabs/TabsConfig.vue'));
    Vue.component('app-stepper', () => import('@/components/user-redesign/stepper/AppStepper.vue'));
    Vue.component('app-stepper-step', () => import('@/components/user-redesign/stepper/AppStepperStep.vue'));
    Vue.component('stepper-config', () => import('@/components/user-redesign/stepper/StepperConfig.vue'));
    Vue.component('app-grid-container', () => import('@/components/user-redesign/grid/AppGridContainer.vue'));
    Vue.component('app-grid-item', () => import('@/components/user-redesign/grid/AppGridItem.vue'));
    Vue.component('app-tooltip', () => import('@/components/user-redesign/AppTooltip.vue'));
    Vue.component('app-watcher', () => import('@/components/user-redesign/AppWatcher.vue'));

    // UI DESIGN NEW
    Vue.component('no-data', () => import('@/packages/ui/components/NoData.vue'));
    Vue.prototype.$user = new User();
    Vue.prototype.$drawer = new Drawer();
    // ! @TODO remove, currently used in some places | deprecated
    Vue.prototype.$modals = Modals;

    Vue.prototype.isProduction = isProductionMode;
    Vue.prototype.isDevelopment = isDevelopmentMode;
    Vue.prototype.isVcht = isVchtMode;

    Vue.filter('truncate', (text, stop, clamp) => text.slice(0, stop) + (stop < text.length ? clamp || '...' : ''));

    const config = isVcht ? ConfigVcht : Config;
    Vue.prototype.$conf = {
      ...config,
      isVcht,
      isVrn,
      isMobile,
      isSafari,
      isMobileSafari,
      isApple,
    };
  },
};
